import React, {useState} from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import {Mutation} from 'react-apollo'
import {message} from 'antd'
import {DeleteOutlined} from '@ant-design/icons'

import AddExecutiveOfficer from './AddExecutiveOfficer'

export const removeExecutiveOfficerMutation = gql`
  mutation RemoveBrokerExecutiveOfficer($input: RemoveBrokerExecutiveOfficerInput!) {
    RemoveBrokerExecutiveOfficer(input: $input) {
      removedExecutiveOfficerId
    }
  }
`

export const addExecutiveOfficerMutation = gql`
  mutation AddBrokerExecutiveOfficer($input: AddBrokerExecutiveOfficerInput!) {
    AddBrokerExecutiveOfficer(input: $input) {
      executiveOfficersEdge {
        node {
          id
          email
        }
      }
    }
  }
`

const ExecutiveOfficersList = ({executiveOfficers}) => {
  const [officers, setOfficers] = useState(executiveOfficers)

  const addOfficer = (mutation, email) => {
    return mutation({
      variables: {
        input: {
          email,
        },
      }
    })
    .then(res => {
      const officer = res.data.AddBrokerExecutiveOfficer.executiveOfficersEdge.node
      setOfficers([...officers, officer])
    })
    .catch(() => {
      message.error('En feil oppstod med å legge til saksbehandler. Vennligst forsøk på nytt eller kontakt EFKT kundeservice.')
    })
  }

  const removeOfficer = (mutation, {id}) => {
    setOfficers(officers.filter(o => o.id !== id))

    return mutation({
      variables: {
        input: {
          executiveOfficerId: id,
        },
      }
    })
    .catch(() => {
      message.error('En feil oppstod med å fjerne saksbehandler. Vennligst forsøk på nytt eller kontakt EFKT kundeservice.')
    })
  }

  return (
    <>
      <Mutation mutation={removeExecutiveOfficerMutation}>
        {(removeExecutiveOfficer) => {
          return (
            <div className="executive-officers-list">
              {officers.map(officer => (
                <div key={officer.id}>{officer.email} <DeleteOutlined onClick={removeOfficer.bind(null, removeExecutiveOfficer, officer)} /></div>
              ))}
            </div>
          )
        }}
      </Mutation>
      <Mutation mutation={addExecutiveOfficerMutation}>
        {(addExecutiveOfficer) => {
          return (
            <AddExecutiveOfficer
              onAddExecutiveOfficer={addOfficer.bind(null, addExecutiveOfficer)}
            />
          )
        }}
      </Mutation>
    </>
  )
}

ExecutiveOfficersList.propTypes = {
  executiveOfficers: PropTypes.array.isRequired,
}

export default ExecutiveOfficersList
